<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#3F033B"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#3F033B" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">{{ msg }}</span>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs9 text-left pb-2>
        <span class="mainHeader">KARIGARS (ARTISANS)</span>
      </v-flex>
      <v-flex xs3 text-right>
        <v-btn dark color="#3F053C" @click="addDialog = true">Add Karigar</v-btn>
      </v-flex>
      <v-flex xs12 py-6 text-left>
        <v-card class="rounded-lg" elevation="0" color="#FFFFFF">
          <v-layout wrap pa-4 v-if="karigarList.length > 0">
            <v-flex xs12>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Name</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Contact</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Specialization</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Action</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, i) in karigarList" :key="i" class="table">
                      <td>{{ value.karigarName }}</td>
                      <td>{{ value.contactNumber }}</td>
                      <td>{{ value.specialization || "-" }}</td>
                      <td>
                        <v-icon size="18" color="#3F053C" class="pr-2" style="cursor: pointer" @click="(curItem = { ...value }), (editDialog = true)">mdi-pencil</v-icon>
                        <v-icon size="18" style="cursor: pointer" @click="(deleteDialog = true), (curId = value._id)">mdi-delete-outline</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout wrap pa-4 v-else>
            <v-flex xs12 text-center>No karigars added yet.</v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog width="500px" v-model="addDialog">
      <v-card width="500px" class="pa-4">
        <span style="color: #3f053c; font-size: 20px">Add Karigar</span>
        <v-layout wrap pt-4>
          <v-flex xs12 pb-2>
            <v-text-field v-model="newKarigar.karigarName" outlined dense label="Name" hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="newKarigar.contactNumber" outlined dense label="Contact Number" hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="newKarigar.specialization" outlined dense label="Specialization (e.g. Repair, Polishing)" hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="newKarigar.address" outlined dense label="Address" hide-details></v-text-field>
          </v-flex>
        </v-layout>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="addDialog = false">Cancel</v-btn>
          <v-btn color="#3F053C" dark @click="addKarigar()">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="500px" v-model="editDialog">
      <v-card width="500px" class="pa-4" v-if="curItem">
        <span style="color: #3f053c; font-size: 20px">Edit Karigar</span>
        <v-layout wrap pt-4>
          <v-flex xs12 pb-2>
            <v-text-field v-model="curItem.karigarName" outlined dense label="Name" hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="curItem.contactNumber" outlined dense label="Contact Number" hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="curItem.specialization" outlined dense label="Specialization" hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="curItem.address" outlined dense label="Address" hide-details></v-text-field>
          </v-flex>
        </v-layout>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="editDialog = false">Cancel</v-btn>
          <v-btn color="#3F053C" dark @click="editKarigar()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="400px" v-model="deleteDialog">
      <v-card width="400px" class="pa-4 text-center">
        <span style="color: #3f053c; font-size: 20px">Delete Karigar</span>
        <v-card-text>Are you sure you want to remove this karigar?</v-card-text>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="#3F053C" dark @click="deleteKarigar()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 2000,
      msg: null,
      karigarList: [],
      addDialog: false,
      editDialog: false,
      deleteDialog: false,
      curId: null,
      curItem: null,
      newKarigar: {
        karigarName: null,
        contactNumber: null,
        specialization: null,
        address: null,
      },
    };
  },
  mounted() {
    this.getKarigarList();
  },
  methods: {
    getKarigarList() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/karigar/getlist",
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.karigarList = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    addKarigar() {
      axios({
        method: "post",
        url: "/karigar/add",
        headers: { "x-auth-token": localStorage.getItem("token") },
        data: this.newKarigar,
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.showsnackbar = true;
          if (response.data.status == true) {
            this.addDialog = false;
            this.newKarigar = { karigarName: null, contactNumber: null, specialization: null, address: null };
            this.getKarigarList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editKarigar() {
      axios({
        method: "post",
        url: "/karigar/edit",
        headers: { "x-auth-token": localStorage.getItem("token") },
        data: {
          id: this.curItem._id,
          karigarName: this.curItem.karigarName,
          contactNumber: this.curItem.contactNumber,
          specialization: this.curItem.specialization,
          address: this.curItem.address,
        },
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.showsnackbar = true;
          if (response.data.status == true) {
            this.editDialog = false;
            this.getKarigarList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteKarigar() {
      axios({
        method: "get",
        url: "/karigar/delete",
        headers: { "x-auth-token": localStorage.getItem("token") },
        params: { id: this.curId },
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.showsnackbar = true;
          this.deleteDialog = false;
          if (response.data.status == true) {
            this.getKarigarList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
